// Module
var code = `<!--<div class="create-details">
    <p class="create-app-status" style="color:#777;">  ⚠️ The Create App feature is temporarily disabled while we improve stability and error handling.    A new version will be available soon.</p>

</div>-->


<div class="create-app-content-holder">
<!--    <header>
        <p>Create a Complete, Structured Application</p>
    </header>-->

<button id="create-app-btn" class="{{disableClass}}"
data-event-type="authEvent"
data-type="createApp"><i class="icon"></i><span class="btn-text">CREATE APP</span></button>
<!--    <p class="create-app-body">Preview online, then download a working project built on VBL — SpyneJS's View · Behavior · Logic architecture — ready to extend.</p>-->
</div>
`;
// Exports
module.exports = code;